export default __webpack_public_path__ + "static/media/a.c26becff.png";